// The one piece of behaviour on the admin compose form: the counts beside each
// kind of question follow the banks that are ticked.
//
// NOT IN packs/. shakapacker.yml sets source_entry_path: packs with
// nested_entries: true, so every file under that directory becomes its own
// webpack entrypoint and emits a bundle no layout ever loads. course_finder.js
// and helpers.js are the existing precedents for a plain module imported by
// packs/application.js.
//
// No framework. This app has neither Turbo nor Stimulus, deliberately.
// setup() early-returns when its markup is absent, so this costs nothing on the
// other ~200 pages the pack is emitted on.
//
// SUMS ONLY, AND THAT IS THE WHOLE CONTRACT. Every number written here is the
// addition of per-bank tallies the server put in the page; nothing here decides
// whether a paper can be drawn. That question is a draw simulation — quotas,
// largest-remainder splits, per-section top-up rungs — and it stays on the
// server, in the feasibility panel. Two answers to it on one page is how this
// app has been wrong before.

function tallyFor(input) {
  try {
    return JSON.parse(input.dataset.bankTypes || "{}");
  } catch (error) {
    return {};
  }
}

function setup() {
  const form = document.querySelector("[data-mock-composer]");
  if (!form) return;

  const boxes = Array.from(
    form.querySelectorAll('input[type="checkbox"][name="mock_request[bank_ids][]"]')
  );
  if (!boxes.length) return;

  function recount() {
    // No box ticked means every active bank, because that is what an empty
    // bank_ids does one level down: MockFormComposer::Blueprint#pool adds no
    // bank clause at all. Summing nothing here would print zeros beside a form
    // that is about to draw from the lot.
    const ticked = boxes.filter((box) => box.checked);
    const counting = ticked.length ? ticked : boxes;

    const totals = counting.reduce((sums, box) => {
      const tally = tallyFor(box);
      Object.keys(tally).forEach((type) => {
        sums[type] = (sums[type] || 0) + tally[type];
      });
      return sums;
    }, {});

    // Every count on the form — the flat paper's kinds and each section's —
    // reads the same map, so a section and the paper above it cannot disagree
    // about what a bank holds.
    form.querySelectorAll(".js-type-count").forEach((node) => {
      node.textContent = ` (${totals[node.dataset.type] || 0})`;
    });
  }

  boxes.forEach((box) => box.addEventListener("change", recount));
  recount();
}

// javascript_pack_tag is deferred (Shakapacker 7 defaults defer: true), so
// DOMContentLoaded may have fired before this module is evaluated — a bare
// listener would never run. This is the guard packs/application.js and
// course_finder.js already use for the same reason.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
